function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  style: {
    enableBackground: "new 0 0 100 100"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 50,
  style: {
    opacity: 0.5,
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#fff"
  },
  d: "M40.2 34.1v32.6L65.9 50z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "play_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: 2.952,
  y1: 91.179,
  x2: 96.396,
  y2: 13.364,
  gradientTransform: "matrix(1 0 0 -1 0 102)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#003ce1"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.137,
  style: {
    stopColor: "#492cd0"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.302,
  style: {
    stopColor: "#920cbd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.452,
  style: {
    stopColor: "#ca01ad"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.582,
  style: {
    stopColor: "#f500a2"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.686,
  style: {
    stopColor: "#fd029a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.751,
  style: {
    stopColor: "#fd0397"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#d80135"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M50 88.1C29 88.1 11.9 71 11.9 50S29 11.9 50 11.9 88.1 29 88.1 50 71 88.1 50 88.1zm0-74.2c-19.9 0-36.1 16.2-36.1 36.1S30.1 86.1 50 86.1 86.1 69.9 86.1 50 69.9 13.9 50 13.9zm31.3 45.2c.8-2.9 1.3-6 1.3-9.1 0-7.3-2.4-14.3-6.9-20-.2-.2-.5-.3-.7-.1-.2.2-.3.5-.1.7 4.4 5.6 6.7 12.3 6.7 19.4 0 3-.4 5.9-1.2 8.8-.1.3.1.5.3.6h.1c.2 0 .4-.1.5-.3zM50.5 82c0-.3-.2-.5-.5-.5-17.4 0-31.5-14.2-31.5-31.5S32.6 18.5 50 18.5c7.8 0 15.3 2.9 21 8 .2.2.5.2.7 0 .2-.2.2-.5 0-.7-6-5.3-13.7-8.3-21.7-8.3-17.9 0-32.5 14.6-32.5 32.5S32.1 82.5 50 82.5c.3 0 .5-.2.5-.5zm20.1-6.8c5.2-4.2 8.9-9.8 10.7-16.2.1-.3-.1-.5-.3-.6-.3-.1-.5.1-.6.3C78.6 64.9 75 70.3 70 74.4c-.2.2-.2.5-.1.7.1.1.2.2.4.2.1 0 .2 0 .3-.1zm-31.3-6.8V31.6L68.2 50 39.3 68.4zm2-33.1v29.4L64.5 50 41.3 35.3z",
  style: {
    fill: "url(#play_svg__a)"
  }
}));
export default SvgPlay;